<template>
<div class="chapter">
<div class="inner_page">
<p class="title-head1"><a id="pg5">C<span class="small">ONTENTS</span></a></p><a id="pg5">
<table>
<colgroup>
<col width="40px"/>
<col width="350px"/>
</colgroup>
<tbody>
<tr><td colspan="2"><span href="#/Title" title="Link target outside of Sample">Title Page</span></td></tr>
<tr><td colspan="2"><span href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></td></tr>
<tr><td colspan="2"><a href="#/Chapter1#C1">1</a></td></tr>
<tr><td colspan="2"><span href="#/Chapter2#C2" title="Link target outside of Sample">2</span></td></tr>
<tr><td colspan="2"><span href="#/Chapter3#C3" title="Link target outside of Sample">3</span></td></tr>
<tr><td colspan="2"><span href="#/Chapter4#C4" title="Link target outside of Sample">4</span></td></tr>
<tr><td colspan="2"><span href="#/Chapter5#C5" title="Link target outside of Sample">5</span></td></tr>
<tr><td colspan="2"><span href="#/Chapter6#C6" title="Link target outside of Sample">6</span></td></tr>
<tr><td colspan="2"><span href="#/Chapter7#C7" title="Link target outside of Sample">7</span></td></tr>
<tr><td colspan="2"><span href="#/Chapter8#C8" title="Link target outside of Sample">8</span></td></tr>
<tr><td colspan="2"><span href="#/Chapter9#C9" title="Link target outside of Sample">9</span></td></tr>
<tr><td colspan="2"><span href="#/Chapter10#C10" title="Link target outside of Sample">10</span></td></tr>
<tr><td colspan="2"><span href="#/Chapter11#C11" title="Link target outside of Sample">11</span></td></tr>
<tr><td colspan="2"><span href="#/Chapter12#C12" title="Link target outside of Sample">12</span></td></tr>
<tr><td colspan="2"><span href="#/Chapter13#C13" title="Link target outside of Sample">13</span></td></tr>
<tr><td colspan="2"><span href="#/Author" title="Link target outside of Sample">About the Author</span></td></tr>
</tbody>
</table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?0b1340f1